var _ellipse, _ellipse2, _ellipse3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#243CBB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9085,
    cy: 61.8937,
    rx: 32.9104,
    ry: 32.9104,
    fill: "#22FFAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_29128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#243CBB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_29128)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_29128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5728 33.1849C36.0019 35.9476 28.3097 48.1901 15.1463 48.1901C1.98286 48.1901 -5.70933 35.8935 -7.28027 33.1849C-0.942338 23.9218 6.04564 20.4549 8.97084 20.4549C11.9502 20.4549 13.5212 22.3509 15.1463 22.3509C16.7714 22.3509 18.3423 20.4549 21.3217 20.4549C24.2469 20.4549 31.2349 23.976 37.5728 33.1849Z",
    fill: "#314DD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.573 33.1849C36.0021 35.9476 28.3099 48.1901 15.1465 48.1901V22.3509C16.7716 22.3509 18.3425 20.4549 21.3219 20.4549C24.2471 20.4549 31.2351 23.976 37.573 33.1849Z",
    fill: "#314DD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5728 33.1849C29.1222 36.056 15.1463 32.264 15.1463 32.264C15.1463 32.264 1.17031 36.056 -7.28027 33.1849C-0.942338 23.9218 6.04564 20.4549 8.97084 20.4549C11.9502 20.4549 13.5212 22.3509 15.1463 22.3509C16.7714 22.3509 18.3423 20.4549 21.3217 20.4549C24.2469 20.4549 31.2349 23.976 37.5728 33.1849Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.146 32.3183C15.146 32.3183 12.8709 32.9142 9.6748 33.4559C12.1125 34.7018 15.2002 34.5935 15.2002 34.5935C15.2002 34.5935 18.2879 34.7018 20.6714 33.4559C17.4212 32.9142 15.146 32.3183 15.146 32.3183Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.573 33.1849C29.1224 36.056 15.1465 32.264 15.1465 32.264V22.3509C16.7716 22.3509 18.3425 20.4549 21.3219 20.4549C24.2471 20.4549 31.2351 23.976 37.573 33.1849Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5532 71.5172V122.953C53.3707 125.656 45.5703 127.124 37.3838 127.124C29.2745 127.124 21.3969 125.656 14.2144 122.953V71.5172C14.2144 64.7208 17.1491 58.6968 21.7058 54.4491C25.7991 50.6647 31.2825 48.3478 37.3838 48.3478C43.4078 48.3478 48.8913 50.6647 52.9845 54.4491C57.6184 58.6196 60.5532 64.7208 60.5532 71.5172Z",
    fill: "#D7DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5532 71.5172V122.953C53.3707 125.656 45.5703 127.124 37.3838 127.124V48.3478C43.4078 48.3478 48.8913 50.6647 52.9845 54.4491C57.6184 58.6196 60.5532 64.7208 60.5532 71.5172Z",
    fill: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9848 46.8033V69.8955C52.9848 78.5454 45.9567 85.4962 37.384 85.4962C28.8114 85.4962 21.7061 78.4682 21.7061 69.8955V46.8033C21.7061 38.1533 28.7341 31.2025 37.384 31.2025C46.034 31.2025 52.9848 38.1533 52.9848 46.8033Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9845 46.8033V69.8955C52.9845 78.5454 45.9565 85.4962 37.3838 85.4962V31.2025C46.0337 31.2025 52.9845 38.1533 52.9845 46.8033Z",
    fill: "#2E293D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.3418 7.27905C55.7513 5.76079 49.1654 5.74517 42.9429 7.0077M37.2512 8.55053C35.3337 9.20544 33.4654 9.98535 31.6581 10.8828C30.3145 11.55 29.0047 12.2822 27.7335 13.0762",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8665 17.9798V60.7367C91.8665 62.0472 90.7984 63.194 89.4017 63.194H81.5145C80.2 63.194 79.0498 62.1291 79.0498 60.7367V17.9798C79.0498 16.6693 80.1179 15.5225 81.5145 15.5225H89.4839C90.7984 15.6044 91.8665 16.6693 91.8665 17.9798Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8663 17.9798V60.7367C91.8663 62.0472 90.7983 63.194 89.4016 63.194H85.458V15.6044H89.4016C90.7983 15.6044 91.8663 16.6693 91.8663 17.9798Z",
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8458 39.6857V61.0641C75.8458 62.2108 74.8599 63.1938 73.7097 63.1938H65.5761C64.4258 63.1938 63.4399 62.2108 63.4399 61.0641V39.6857H75.8458Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6138 26.4164H64.5898V39.6867H74.6138V26.4164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3823 19.2084V26.4983H65.8237V19.2084C65.8237 17.0787 66.0702 15.1948 66.481 13.5566L69.603 10.9355L70.9997 9.70685C72.3964 11.1812 73.3823 14.8672 73.3823 19.2084Z",
    fill: "#00E98F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8673 38.1295H79.0498V40.5869H91.8673V38.1295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8659 38.1295H85.458V40.5866H91.8659V38.1295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8456 39.6857V61.0641C75.8456 62.2108 74.8597 63.1938 73.7095 63.1938H69.6016V39.6857H75.8456Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6135 26.4164H69.6016V39.6867H74.6135V26.4164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3804 19.2085V26.4985H69.6011V10.9356L70.9978 9.70697C72.3945 11.1813 73.3804 14.8673 73.3804 19.2085Z",
    fill: "#22FFAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_29128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5871,
    height: 195.909,
    fill: "white",
    transform: "translate(-5.54688 -91.8727)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.8afd37b44e20d760236c84e590d59886.svg";
export { ForwardRef as ReactComponent };